import React, {useEffect, useRef, useState} from 'react';
import CardHeader from '../../components/common/card-header/CardHeader';
import {
  Card,
  FlexItem,
  FlexLayout, Text,
  StackLayout
} from '@salt-ds/core';
import StepTracker from '../../components/common/StepTracker';

import '../CommonCard.css';
import ForgotPasswordTwoStepVerificationForm from './ForgotPasswordTwoStepVerificationForm';
import Constants from '../../components/common/Constants';
import CardAlert from '../../components/common/card-alert/CardAlert';
import {useLocation, useNavigate} from 'react-router';
import {useIntl} from 'react-intl';

function ForgotPasswordTwoStepVerification() {

  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const mainRef = useRef(null);

  const [showBanner, setShowBanner] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [statusIcon, setStatusIcon] = useState("info");
  const [bannerText, setBannerText] = useState(Constants.forgotPasswordDefaultAccessCodeMessage);
  const {formData} = location.state || {formData: {userId: "", email: "", orgId: ""}};
  const [errorMessage, setErrorMessage] = useState();
  const [hasError, setHasError] = useState(false);

  const [headerContent, setHeaderContent] = useState(<CardAlert status={statusIcon} setShowBanner={setShowBanner}>
    {bannerText}
  </CardAlert>);

  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.forgotpassword.step2.page.title'});
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }

    const expectedPreviousPage = '/forgotPassword';
    if (location.state?.from !== expectedPreviousPage) {
      navigate('/');
    }
  }, [intl, location, navigate]);

  useEffect(() => {
    setHeaderContent(
      <CardAlert status={statusIcon} setShowBanner={setShowBanner}>
        {bannerText}
      </CardAlert>
    );
  }, [statusIcon, bannerText, setShowBanner]);

  const showErrorOnPage = (error) => {
    setErrorMessage(error);
    setHasError(true);
  }

  return (
  <main ref={mainRef} role="main" aria-label="Forgot Password Two Step Verification" tabIndex="-1">
    <FlexLayout className={"page-content"}>
      <FlexItem className={`error-wrapper ${showBanner || isLoading ? 'visible' : ''}`}>
        <div>
          {headerContent}
        </div>
      </FlexItem>

      <FlexItem>
        <Card className="card-wrapper">
          <FlexItem className="card-content">
            <StackLayout gap={2}>

              <CardHeader data-testid="card-header" heading={Constants.forgotPasswordTitle}
                subheading={Constants.forgotPasswordStep2Title}
                style={{maxWidth: "15.5rem"}} />

              <StepTracker label1={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step1'})} step1="completed"
                label2={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step2'})} step2="active"
                label3={intl.formatMessage({id: 'logon.ui.forgotpassword.flow.step3'})} step3="pending" />

              <FlexItem>
                <Text>
                  {Constants.forgotPasswordStep2InstructionHeader} </Text>
              </FlexItem>
              <ForgotPasswordTwoStepVerificationForm formData={formData}
                headerContent={headerContent} setHeaderContent={setHeaderContent}
                showBanner={showBanner} setShowBanner={setShowBanner}
                isLoading={isLoading} setIsLoading={setIsLoading}
                statusIcon={statusIcon} setStatusIcon={setStatusIcon}
                bannerText={bannerText} setBannerText={setBannerText}
                showErrorOnPage={showErrorOnPage}
              />

            </StackLayout>
          </FlexItem>
        </Card>

      </FlexItem>
    </FlexLayout>
  </main>
  );
}

export default ForgotPasswordTwoStepVerification;